// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"D_cP","articlesContent":"D_cQ","lastes":"D_cR","popular":"D_cS","article":"D_cT","sectionTitle":"D_bp","imgArticle":"D_cV","articleDate":"D_cW"};